import React, { Component } from "react"
import banner from '../images/banner.jpg'

class Disclaimer extends Component {
  render() {
    const pageContent = this.props.data.contentfulPageContent;
    return (
      <div id="page-wrapper">
        <section className="main alt">
          <header>
            <h1>{pageContent.title}</h1>
            {/* <p>Read this.</p> */}
          </header>
          <div className="inner style2">
            {/* <div className="image main" data-position="center"> */}
              {/* <img src={banner} alt="" /> */}
            {/* </div> */}
            <span dangerouslySetInnerHTML={{ __html: pageContent.content.childMarkdownRemark.html }} />
          </div>
        </section>
      </div>
    );
  }
}

export default Disclaimer

export const pageQuery = graphql`
query disclaimerQuery {
    contentfulPageContent(slug: {eq: "disclaimer"}){
      title
      content {
          childMarkdownRemark {
              html
          }
      }
    }        
}
`


// WEBPACK FOOTER //
// ./src/pages/disclaimer.js